<template>
    <div class="generic-chart">
      <apexchart
        v-if="chartOptions && series && series.length"
        :type="type"
        :options="chartOptions"
        :series="series"
        :xaxis="xAxis"
        height="280px"
      />
    </div>
  </template>
  
  <script>
  import VueApexCharts from 'vue-apexcharts';
  
  export default {
    name: 'GenericChart',
    components: {
      apexchart: VueApexCharts,
    },
    props: {
      xAxis: {
        type: Array,
        required: true,
      },
      yAxis: {
        type: String,
        required: false,
        default: '',
      },
      type: {
        type: String,
        default: 'bar',
      },
      series: {
        type: Array,
        required: true,
      },
      colors: {
        type: Array,
        default: () => ['#2774E9', '#22d06c', '#ffc32b', '#8e44ad', '#e67e22'],
      },
      showXAxisLabels: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      chartOptions() {
        const baseOptions = {
          chart: {
            id: 'generic-chart',
            toolbar: { show: false },
          },
          dataLabels: { enabled: false },
          tooltip: { 
            enabled: true,
            theme: 'dark',
            style: {
              fontSize: '12px',
              color: '#ffffff',
              backgroundColor: '#000000'
            }
          },
          colors: this.colors,
        };

        // Pie chart specific options
        if (this.type === 'pie') {
          return {
            ...baseOptions,
            labels: this.xAxis,
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
            },
            plotOptions: {
              pie: {
                donut: {
                  size: '0%'
                }
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          };
        }

        // Default options for bar/line charts
        return {
          ...baseOptions,
          xaxis: {
            categories: this.xAxis,
            labels: { show: this.showXAxisLabels },
          },
          yaxis: {
            title: { text: this.yAxis },
            labels: {
              formatter: function (val) {
                if (Math.abs(val) >= 1e6) return (val / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                if (Math.abs(val) >= 1e3) return (val / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                return val;
              }
            }
          },
          grid: { strokeDashArray: 4 },
          legend: { 
            show: this.type !== 'bar' // Hide legend for bar charts
          },
          plotOptions: {
            bar: {
              distributed: true, // This applies different colors to each bar
            },
          },
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .generic-chart {
    width: 100%;
    height: 180px;
    margin: 0 auto 1.5rem auto;
  }
  </style> 